import { isAddable } from './destination-kinds';
import type { PaigeDestination, PaigeDestinationRemoved } from './paige.global';

/**
 * What Remove asks before a destination goes, as CapturePoint asks before it stops sending to one
 * (ad431f3d, "1 document waiting for Box won't be sent there"): how many documents are waiting to go
 * there, parked ones included (`unsent`), since removing cancels them
 * (services/Paige.Ledger/Records/DestinationRemoval.cs).
 */
export function waitingLine(row: Pick<PaigeDestination, 'unsent'>): string {
  if (row.unsent <= 0) return 'Nothing is waiting to go there.';
  return row.unsent === 1
    ? '1 document is waiting to go there.'
    : `${row.unsent} documents are waiting to go there.`;
}

/** The job's other destinations the waiting documents can be sent to instead: never Download or itself. */
export function handoverTargets(
  rows: readonly PaigeDestination[],
  removed: Pick<PaigeDestination, 'id' | 'unsent'>,
): PaigeDestination[] {
  if (removed.unsent <= 0) return [];
  return rows.filter((r) => r.id !== removed.id && isAddable(r.kind));
}

/** The card's line once it is gone, with where the waiting documents went when they were sent on. */
export function removedLine(
  row: Pick<PaigeDestination, 'label'>,
  result: PaigeDestinationRemoved | undefined,
  target: Pick<PaigeDestination, 'label'> | undefined,
): string {
  if (!result || !target || result.queued <= 0) return `${row.label} removed`;
  const documents = result.queued === 1 ? '1 document' : `${result.queued} documents`;
  return `${row.label} removed; ${documents} on the way to ${target.label}`;
}
